import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';

import VisualizerSaveForm from './VisualizerSaveForm';
import VisualizerSaveSuccess from './VisualizerSaveSuccess';

var VisualizerSaveModal = function VisualizerSaveModal(_ref) {
  var active = _ref.active,
      closeModalFunc = _ref.closeModalFunc,
      queryParams = _ref.queryParams,
      user = _ref.user,
      selectedProducts = _ref.selectedProducts,
      isWallGallery = _ref.isWallGallery;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      visualizerTitle = _useState2[0],
      setVisualizerTitle = _useState2[1];

  return React.createElement(
    Modal,
    { active: active, closeModalFunc: closeModalFunc },
    visualizerTitle === '' ? // set on form submit
    React.createElement(VisualizerSaveForm, {
      queryParams: queryParams,
      setVisualizerTitle: setVisualizerTitle,
      user: user,
      selectedProducts: selectedProducts
    }) : React.createElement(VisualizerSaveSuccess, {
      title: visualizerTitle,
      closeModalFunc: closeModalFunc,
      isWallGallery: isWallGallery
    })
  );
};

VisualizerSaveModal.propTypes = {
  active: PropTypes.bool.isRequired,
  closeModalFunc: PropTypes.func.isRequired,
  queryParams: PropTypes.string,
  user: PropTypes.object,
  selectedProducts: PropTypes.array,
  isWallGallery: PropTypes.bool
};

export default VisualizerSaveModal;